function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.475 10.4833C13.1042 9.49164 14.1666 7.72084 14.1666 5.66668C14.1667 2.55 11.6166 0 8.5 0C5.38336 0 2.83332 2.55 2.83332 5.66668C2.83332 7.72084 3.89581 9.49168 5.52497 10.4833C2.69164 11.5458 0.566645 14.025 0 17H1.41668C2.125 13.7417 5.02919 11.3333 8.5 11.3333C11.9708 11.3333 14.875 13.7416 15.5833 17H17C16.4334 13.9542 14.3084 11.475 11.475 10.4833ZM4.25 5.66668C4.25 3.32919 6.16252 1.41668 8.5 1.41668C10.8375 1.41668 12.75 3.32919 12.75 5.66668C12.75 8.00416 10.8375 9.91668 8.5 9.91668C6.16252 9.91668 4.25 8.00416 4.25 5.66668Z",
  fill: "white"
});

function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.8567aa9c.svg";
export { ForwardRef as ReactComponent };